import { Injectable } from '@angular/core';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  LocalStorageService,
  environment,
} from '@ups/xplat/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ParentCustomerDto, ProfileModel } from '@ups/xplat/api/dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchCustomerVPService {
  private http: HttpClient;
  private vpHttp: HttpClient;
  private profile: ProfileModel;

  constructor(
    private clientFactory: MyHttpClientFactory,
    private storage: LocalStorageService
  ) {
    this.http = this.clientFactory.createHttpClient(
      environment.urls.spartaAPI,
      true,
      ResponseCasingEnum.PascalCase
    );
    this.vpHttp = this.clientFactory.createHttpClient(
      environment.urls.viewpointAPI,
      true,
      ResponseCasingEnum.PascalCase
    );
    this.profile = this.storage.getItem('profile') as ProfileModel;
  }

  search(
    searchString: string,
    params: HttpParams = null,
    limit: number = 50
  ): Observable<ParentCustomerDto[]> {
    params = params || new HttpParams();
    params = params.append('searchString', searchString);
    params = params.append('take', limit);
    return this.vpHttp.get<ParentCustomerDto[]>(`/api/parentCustomers`, {
      params,
    });
  }

  /* eslint-disable */
  public addOrRemoveFavoriteCustomer(vpParentCustomerKeyID: string | number) {
    const url = `/api/parentCustomers/favorite`;
    this.http
      .post(url, {
        UserID: this.profile.auth0UserId,
        VPParentCustomerKeyID: vpParentCustomerKeyID,
      })
      .toPromise();
  }
  /* eslint-enable */
}
